export default __webpack_public_path__ + "static/media/frame4.68f283fd.png";